import { merge } from 'lodash';
// Using this module only because crypto library causes tests to run out of memory
import { sha256 } from 'js-sha256';
import moment from 'moment';
import { hash as md5 } from 'spark-md5';

/**
 * @function hashInput
 *
 * @description
 * Hash a string using sha256 algorithm
 *
 * @param {String} input     Input string to be encoded
 * @return {String}          Hashed representation of input
 */
export function hashInput(input) {
    return sha256(input);
}

// Copy-pastaaa
// https://stackoverflow.com/questions/21647928/javascript-unicode-string-to-hex
// Looks right
String.prototype.hexEncode = function(){
    let hex, i;

    let result = "";
    for (i = 0; i < this.length; i++) {
        hex = this.charCodeAt(i).toString(16);
        result += ("0" + hex).slice(-2);
    }

    return result
};

export function generateUserHash(pdpOptions, userObj, newUserName = null, userEmail = '') {
    const today = moment().format('YYYYMMDD');

    const userDefaults = {
        webPreferences: {
            legacyWebId: 0
        },
        profileId: 0,
        loyaltyUserName: ''
    };
    const options = _.merge(userDefaults, userObj);

    // Use usernickname from form if it differed from profile
    if (newUserName) {
        options.loyaltyUserName = newUserName;
    }

    let user = options.profileId ? options.profileId : userEmail;

    if (pdpOptions.use_legacy_id_for_reviews && options.webPreferences.legacyWebId !== 0) {
        user = options.webPreferences.legacyWebId;
    }

    const hashKey = pdpOptions.review_hash_key;
    const str = `date=${today}&userid=${user}&username=${options.loyaltyUserName}`;
    const hashString = md5(hashKey + str);
    const hexString = str.hexEncode();

    return `${hashString}${hexString}`;
}

export default {
    generateUserHash: generateUserHash
};
